import React, { FC, memo } from 'react';
import { ImageMedia, VideoMedia } from '~/lib/data-contract';
import { MediaImage, Video } from '~/shared/components';
import { useCookieConsent } from '~/shared/hooks';
import { getObjectPosition } from '~/shared/utils';
import styles from './category-card-media.module.css';

type Props = {
    image?: ImageMedia;
    video?: VideoMedia;
    imgSizes?: string;
    is4by5?: boolean;
};

const CategoryCardMedia: FC<Props> = memo((props) => {
    const { image, video, imgSizes, is4by5 } = props;
    const imgSrc = image?.src || '';
    const videoSrc = video?.src || '';

    const { marketing, statistic } = useCookieConsent();

    if (!imgSrc && !videoSrc) {
        return null;
    }

    const objectPosition = getObjectPosition(image?.focalPoint);

    const shouldRenderVideo =
        videoSrc && ((marketing && statistic) || (!(marketing && statistic) && !imgSrc));

    if (shouldRenderVideo) {
        return (
            <Video
                controls={false}
                src={videoSrc}
                loop={video?.loop}
                playing={true}
                posterSrc={imgSrc}
                cover={true}
                showCustomButtons={false}
                posterSizes={imgSizes}
            />
        );
    }

    if (imgSrc) {
        return (
            <MediaImage
                {...image}
                src={imgSrc}
                fill
                alt="M10 Test"
                className={styles.image}
                sizes={imgSizes}
                cW={is4by5 ? 4 : undefined}
                cH={is4by5 ? 5 : undefined}
                style={{
                    objectPosition,
                }}
            />
        );
    }

    return null;
});

CategoryCardMedia.displayName = 'CategoryCardMedia';
export { CategoryCardMedia };
